import { AUTODISPATCH_DELIVERY_BLOCK_RESOURCES_FF, hasCombinedOptimization } from '@bringg-frontend/global-stores';

import useStores from '../../../recipes/use-stores';
import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import type Team from 'bringg-web/stores/teams/domain-object/team';

export const useHasCombinedOptimization = (team?: Team) => {
	const { applicationMerchantConfigurationStore, applicationTeamConfigurationStore } = useStores();
	const isAutoDispatchResourcesEnabled = useHasFeatureFlag(AUTODISPATCH_DELIVERY_BLOCK_RESOURCES_FF);

	return hasCombinedOptimization({
		team,
		merchantConfigs: applicationMerchantConfigurationStore,
		teamConfigs: applicationTeamConfigurationStore,
		isAutoDispatchResourcesEnabled
	});
};
